import Vue from 'vue';


let initialStore = {
    myUser: null,
    showSidebar: false,
    showAllVideosInFeed: false,
    showStaffControls: false
}

export let store = {}

export function resetStore() {
    for (let member in store) delete store[member];
    let newStore = JSON.parse(JSON.stringify(initialStore))
    for (let k in newStore) { // noinspection JSUnfilteredForInLoop
        store[k] = newStore[k]
    }
}

resetStore()

export let eventBus = new Vue()

export let backendURL
export let websocketsURL
export let hostname

if (process.env.VUE_APP_BACKEND_HOST && process.env.VUE_APP_BACKEND_HOST !== 'false')
    hostname = process.env.VUE_APP_BACKEND_HOST
else
    hostname = location.hostname

if (process.env.VUE_APP_BACKEND_PORT && process.env.VUE_APP_BACKEND_PORT !== 'false')
    backendURL = location.protocol + '//' + hostname + ':' + process.env.VUE_APP_BACKEND_PORT
else
    backendURL = '';

let websocketsProtocol = location.protocol === 'http:' ? 'ws:' : 'wss:'
if (process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT && process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT !== 'false')
    websocketsURL = websocketsProtocol + '//' + hostname + ':' + process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT + '/ws'
else if (hostname === 'localhost' && process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT_IF_LOCALHOST &&  process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT_IF_LOCALHOST !== 'false')
    websocketsURL = websocketsProtocol + '//' + hostname + ':' + process.env.VUE_APP_WEBSOCKETS_BACKEND_PORT_IF_LOCALHOST + '/ws'
else
    websocketsURL = websocketsProtocol + '//' + process.env.VUE_APP_PRODUCTION_WEBSOCKETS_SUBDOMAIN + '.' + hostname + (location.port ? ':' + location.port : '')  + '/ws'